/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportCollaborationStatusTypeEnum } from './e-transport-collaboration-status-type.enum';

export class ETransportNotificationViewVoModel extends JSONable {
  uuid = '';
  owner: string | null = null;
  createdBy: string | null = null;
  isUploadReady = false;
  uit: string | null = null;
  isUitValid: string | null = null;
  operationType: string | null = null;
  shipmentDate: string | null = null;
  validUntil: string | null = null;
  expiresIn : string | null = null;
  commercialPartnerName: string | null = null;
  commercialPartnerLegalEntityUuid: string | null = null;
  hasCommercialPartnerContacts = false;
  shipmentOrganizerName: string | null = null;
  shipmentOrganizerLegalEntityUuid: string | null = null;
  hasShipmentOrganizerContacts = false;
  licensePlate: string | null = null;
  latestVehicleModifiedDate: string | null = null;
  startLocation: string | null = null;
  endLocation: string | null = null;
  uploadStatus: string | null = null;
  checkStatus: string | null = null;
  latestActionUuid: string | null = null;
  latestActionType: string | null = null;
  latestActionUploadStatus: string | null = null;
  latestActionCheckStatus: string | null = null;
  latestActionStatus: string | null = null;
  confirmationType: string | null = null;
  confirmationTypeUuid: string | null = null;
  anafMessage: string | null = null;
  orderUuid: string | null = null;
  orderNumber: string | null = null;
  externalReference: string | null = null;
  collaborationStatus: ETransportCollaborationStatusTypeEnum | null = null;
  state = new ETransportNotificationState();

  // frontend only
  showMessage = false;
}

class ETransportNotificationState {
  canEdit = false;
  canUpload = false;
  canCheck = false;
  canCollaborateCommercialPartner = false;
  canCollaborateShipmentOrganizer = false;
  canPerformCancel = false;
  canPerformConfirmation = false;
  canPerformModifVehicle = false;
  canDelete = false;
  canEmailCommercialPartner = false;
  canEmailShipmentOrganizer = false;
}
